import { Badge } from "@chakra-ui/react";

export default function SpacedustEphemeralBadge() {
  return (
    <Badge colorScheme="plum" p={2} variant="solid">
      Ephemeral Environment
    </Badge>
  );
}
